import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "order-actions__next" }
const _hoisted_2 = {
  key: 0,
  class: "order-actions__previous"
}
const _hoisted_3 = {
  key: 1,
  class: "order-actions__text-required"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppOrderActions',
  props: {
    labels: {},
    colorPrevious: { default: 'dark-outline' },
    colorNext: { default: 'red-orange' },
    hideRequiredHint: { type: Boolean }
  },
  emits: ['previous', 'next'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const internetModal = document.getElementsByClassName('priceshow-internet-configuration')[0];

const toTop = () => {
  if (internetModal) {
    internetModal.scrollIntoView({ behavior: 'smooth' });
  }
};

const handleNextClick = () => {
  emit('next');
  if (internetModal) {
    toTop();
  }
};

const handlePreviousClick = () => {
  emit('previous');
  if (internetModal) {
    toTop();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-actions", {
        'has-previous': !!_ctx.labels.previous
      }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseButton, {
        align: "end",
        color: _ctx.colorNext,
        "link-type": "button",
        width: "full auto-md",
        onClick: _withModifiers(handleNextClick, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.labels.next), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    (_ctx.labels.previous)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_BaseButton, {
            align: "start",
            color: _ctx.colorPrevious,
            "link-type": "button",
            width: "full auto-md",
            onClick: _withModifiers(handlePreviousClick, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.labels.previous), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideRequiredHint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Mit * markierte Felder sind Pflichtfelder. "))
      : _createCommentVNode("", true)
  ], 2))
}
}

})